import { useDisciplineContext } from './discipline-context.hook'

interface DisciplineRefreshOptions {
  withSiblings?: boolean
}

interface DisciplineRefreshReturn {
  refreshDiscipline: (options?: DisciplineRefreshOptions) => Promise<void>
}

/** Rereads what the header, the tab menu and the General info tab show, under the page loader. The sibling list
 *  lives on the customer read, so it is reread only when a write added or removed a discipline. */
export const useDisciplineRefresh = (): DisciplineRefreshReturn => {
  const route = useRoute()
  const { loadContext } = useDisciplineContext()

  const refreshDiscipline = (options: DisciplineRefreshOptions = {}): Promise<void> =>
    loadContext(route.params.id as string, { force: true, withCustomer: options.withSiblings })

  return {
    refreshDiscipline,
  }
}
